import axios from "../lib/api.request";

export const getOssData = (uploadSignURL) => {
  return axios.request({   //新签名地址：https://test-k8s-api.dbxiao.cn/phoenix/usercenter3/api/v2/demo/upload/getUploadSignPutUrl
    url: uploadSignURL || "/phoenix/usercenter3/api/v2/demo/upload/getUploadSignPutUrl",
    method: "get",
    noLoading: true,
  });
}
export const getExcelOssData = (uploadSignURL) => {
  return axios.request({
    url: `${uploadSignURL}/getUploadSignPutUrl`,
    method: "get",
    noLoading: true,
  });
}
export const getExtendInfoData = (ossImgUrl) => {
  return axios.request({
    url: ossImgUrl,
    method: "get",
    noLoading: true,
  });
}
export const findImportInfo = ({ templateSn, bizParam }, url) => {

  return axios.request({
    url: `${url}/findImportInfo`,
    method: "post",
    noLoading: true,
    data: {
      templateSn,
      bizParam
    }
  });
}
export const confirmFileUpload = ({ importToken, excelFile }, url) => {
  return axios.request({
    url: `${url}/confirmFileUpload`,
    method: "post",
    noLoading: true,
    data: {
      importToken,
      excelFile
    }
  });
}
export const getParseAndCheckState = (importToken, url) => {
  return axios.request({
    url:`${url}/getParseAndCheckState`,
    method: "get",
    noLoading: true,
    params: { importToken }
  });
}
export const queryPreviewData = ({ importToken, onlyShowError, pageNumber = 1, pageSize = 20 }, url) => {
  return axios.request({
    url: `${url}/queryPreviewData`,
    method: "post",
    noLoading: true,
    data: { importToken, onlyShowError, pageNumber, pageSize }
  });
}
export const doImport = (importToken, url) => {
  return axios.request({
    url: `${url}/doImport`,
    method: "post",
    noLoading: true,
    data: { importToken }
  });
}
export const getImportResult = (importToken, url) => {
  return axios.request({
    url: `${url}/getImportResult`,
    method: "get",
    noLoading: true,
    params: { importToken }
  });
}
export const closeImport = (importToken, url) => {
  return axios.request({
    url: `${url}/closeImport`,
    method: "post",
    noLoading: true,
    data: { importToken }
  });
}
// 获取组件的上传类型（阿里云/天翼云）
export const checkUploader = ({url, type}) => {
  return axios.request({
    url,
    method: "get",
    noLoading: true,
    params: { type }
  })
}
// 资源文件整体上传签名（阿里云/天翼云的文档上传）
export const documentResourceSign = ({url, typeEnum}) => {
  return axios.request({
    url,
    method: "get",
    noLoading: true,
    params: { typeEnum }
  })
}
// 天翼云音视频分片上传获取签名
export const splitUploadSign = ({url, typeEnum, partSize}) => {
  return axios.request({
    url,
    method: "get",
    noLoading: true,
    params: { typeEnum, partSize }
  });
}
// 分片上传全部结束后，调取此接口，⾳视频，分⽚上传完成通知
export const splitUploadComplete = ({url, ossTypeEnum, fileKey, uploadId, etags}) => {
  return axios.request({
    url,
    method: "post",
    noLoading: true,
    data: { ossTypeEnum, fileKey, uploadId, etags }
  });
}
// 获取资源列表
export const getResourceCategoryList = (url) => {
  return axios.request({
    url,
    method: 'get',
    noLoading: true
  })
} 